import React from 'react';
import ResponsiveImageView from 'lib/images/responsive-image-view';
import Styled from 'styled';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import defaultStyles from './gallery-image-view.scss';

// const arrows = require('./icon_scale-image.svg');

@Styled(defaultStyles)
@observer
class ImageView extends React.Component {
    @observable shown = false;

    render() {
        const { styles, onClick, moreImagesCount, ...rest } = this.props;

        const classNames = [styles.galleryImage];

        if (moreImagesCount) {
            classNames.push(styles.hasMoreImages);
        }

        return (
            <div className={classNames.join(' ')}>
                <div className={styles.images}>
                    <ResponsiveImageView aspectFill={true} {...rest} />
                </div>
                <button aria-label='open-image' onClick={onClick} className={styles.background} />
                {moreImagesCount > 0 ? (
                    <button onClick={onClick} className={styles.moreImages} aria-label='open-more-images'>
                        +{moreImagesCount}
                    </button>
                ) : null}
            </div>
        );
    }
}

export default ImageView;
